import React from 'react';
import Icon from '../../../components/AppIcon';

const CompanyCulture = ({ company }) => {
  return (
    <div className="bg-muted/30 py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Our Culture & Values
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Discover what makes {company?.name} a great place to grow your career
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {company?.cultureValues?.map((value, index) => (
            <div 
              key={index}
              className="bg-card rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-border group hover:-translate-y-1"
            >
              <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-4 ${value?.bgColor} group-hover:scale-110 transition-transform`}>
                <Icon name={value?.icon} size={28} color={value?.iconColor} />
              </div>
              
              <h3 className="text-xl font-semibold text-foreground mb-2">
                {value?.title}
              </h3>
              
              <p className="text-muted-foreground leading-relaxed">
                {value?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompanyCulture;